import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  Typography,
  IconButton,
} from '@mui/material';
import {
  Clear as ClearIcon,
  Save as SaveIcon,
  Business as BusinessIcon,
  LockOutlined as LockOutlinedIcon,
} from '@mui/icons-material';
import { useMaterialUIController } from 'context';
import { tienePermisosModulo, getPermisosPorModulo } from 'lib/seguridad/permisosPorModulo';
import { FP, fpInputSx } from 'components/financepro';
/** Igual que `ListadoProductos.jsx`: acceso al área vs. permiso de guardar/editar. */
const PROGRAMA_ACCESO = 'agregardepartamentos';
const PROGRAMA_GUARDAR = 'agregardepartamentos';

const AgregarDepartamento = ({ open, onClose, onGuardar, selectedCompany, showSuccess, showError }) => {
  const [controller] = useMaterialUIController();
  const { roleDetalles, usuarioLog, claveLog } = controller;
  const tienePermisoAcceso = tienePermisosModulo(roleDetalles, PROGRAMA_ACCESO);
  const puedeGuardar = getPermisosPorModulo(roleDetalles, PROGRAMA_GUARDAR);

  console.log(puedeGuardar.registro.insertar,"puedeGuardar");
  const [nombreDepartamento, setNombreDepartamento] = useState('');

  const handleGuardar = async () => {
    if (!puedeGuardar) {
      showError('No tiene permisos para guardar departamentos (programa de edición de productos).');
      return;
    }
    if (!nombreDepartamento.trim()) {
      showError('El nombre del departamento es requerido');
      return;
    }

    try {
      const servidor = process.env.REACT_APP_SERVIDOR || '';
      const response = await fetch(servidor + '/api/productosbackend_guardardepartamentos', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id_empresa: selectedCompany,
          usuario: usuarioLog || '',
          password: claveLog || '',
          nombre: nombreDepartamento.trim().toUpperCase(),
        }),
      });

      if (response.ok) {
        const data = await response.json();
        showSuccess(data.mensaje || 'Departamento guardado exitosamente');
        setNombreDepartamento('');
        onGuardar();
        onClose();
      } else {
        const errorData = await response.json();
        showError(errorData.Error || 'Error al guardar el departamento');
      }
    } catch (error) {
      showError('Error de conexión al guardar departamento');
    }
  };

  const handleClose = () => {
    setNombreDepartamento('');
    onClose();
  };

  const cancelOutlineSx = {
    height: 46,
    borderColor: FP.color.border,
    color: FP.color.textSecondary,
    bgcolor: '#FFFFFF',
    borderRadius: 1.6,
    textTransform: 'none',
    fontWeight: 700,
    '&:hover': {
      bgcolor: FP.color.surfaceAlt,
      borderColor: FP.color.borderStrong,
      color: FP.color.navy,
    },
  };

  const primaryGuardarSx = {
    bgcolor: FP.color.navy,
    color: '#FFFFFF',
    borderRadius: 1.4,
    px: 2.2,
    height: 38,
    boxShadow: 'none',
    textTransform: 'none',
    fontWeight: 700,
    '&:hover': { bgcolor: FP.color.navyDeep, boxShadow: 'none' },
    '&.Mui-disabled': { bgcolor: '#E2E8F0', color: '#94A3B8' },
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2.5,
          border: `1px solid ${FP.color.border}`,
          boxShadow: FP.shadow.md,
          minWidth: 300,
          maxWidth: '90vw',
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          rowGap: 1.5,
          columnGap: 2,
          px: 3,
          py: 2,
          borderBottom: `1px solid ${FP.color.border}`,
          bgcolor: '#FAFBFE',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.2,
            flex: '1 1 auto',
            minWidth: 0,
          }}
        >
          <Box
            sx={{
              width: 30,
              height: 30,
              borderRadius: 1.2,
              bgcolor: FP.color.accentBlueSoft,
              color: FP.color.accentBlue,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            <BusinessIcon sx={{ fontSize: 18 }} />
          </Box>
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: '1rem',
              color: FP.color.textPrimary,
              wordBreak: 'break-word',
            }}
            component="span"
          >
            Agregar departamento
          </Typography>
        </Box>
        <IconButton
          onClick={handleClose}
          size="small"
          sx={{
            color: FP.color.textSecondary,
            border: `1px solid ${FP.color.border}`,
            borderRadius: 1.2,
            width: 32,
            height: 32,
            flexShrink: 0,
            '&:hover': { bgcolor: FP.color.surfaceAlt, color: FP.color.navy },
          }}
        >
          <ClearIcon sx={{ fontSize: 18 }} />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: 3, overflow: 'visible' }}>
        <Box sx={{ pt: 0.5 }}>
          {!tienePermisoAcceso ? (
            <Box sx={{ textAlign: 'center', py: 2, px: 1 }}>
              <Box
                sx={{
                  width: 56,
                  height: 56,
                  borderRadius: 1.6,
                  mx: 'auto',
                  mb: 2,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  bgcolor: FP.color.dangerSoft,
                  color: FP.color.danger,
                }}
              >
                <LockOutlinedIcon sx={{ fontSize: 26 }} />
              </Box>
              <Typography
                sx={{
                  fontWeight: 800,
                  fontSize: '1.05rem',
                  color: FP.color.textPrimary,
                  mb: 1,
                }}
              >
                Acceso denegado
              </Typography>
              <Typography sx={{ color: FP.color.textSecondary, fontSize: '0.9rem', mb: 0.5 }}>
                No tiene permisos para esta función (programa &quot;{PROGRAMA_ACCESO}&quot; en roles).
              </Typography>
              <Typography sx={{ color: FP.color.textMuted, fontSize: '0.85rem' }}>
                Solicite al administrador el acceso correspondiente.
              </Typography>
            </Box>
          ) : (
            <>
              {!puedeGuardar.registro.insertar && (
                <Typography sx={{ mb: 2, color: FP.color.danger, fontSize: '0.88rem', fontWeight: 600 }}>
                  No tiene permisos para guardar departamentos (programa &quot;{PROGRAMA_GUARDAR}&quot;). Puede
                  cerrar este cuadro; la selección de categorías existentes en el formulario no requiere este permiso.
                </Typography>
              )}
              <TextField
                fullWidth
                label="Nombre del departamento"
                value={nombreDepartamento}
                onChange={(e) => setNombreDepartamento(e.target.value.toUpperCase())}
                required
                autoFocus
                disabled={!puedeGuardar}
                inputProps={{ maxLength: 100 }}
                InputLabelProps={{ shrink: true }}
                sx={fpInputSx}
                helperText="Ingrese el nombre del nuevo departamento"
              />
            </>
          )}
        </Box>
      </DialogContent>
      <DialogActions
        sx={{
          p: 2.5,
          pt: 1,
          gap: 1.2,
          flexWrap: 'wrap',
          borderTop: `1px solid ${FP.color.border}`,
          bgcolor: FP.color.surface,
        }}
      >
        <Button variant="outlined" onClick={handleClose} sx={cancelOutlineSx}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          startIcon={<SaveIcon />}
          onClick={handleGuardar}
          disabled={!tienePermisoAcceso || !puedeGuardar}
          sx={primaryGuardarSx}
        >
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AgregarDepartamento;
